import { Injectable } from '@angular/core';
import { OrganizationApiService } from '../organization-api.service';
import { handleApiCallAsync } from '../../../../utils/general-functions';
import { IUpdateOrganizationRequestBody } from '../../../http-models/organization/organization-request-model';
import { IPaginationQuery } from '../../../../models/defines';
import { WithOrganWsStateBase } from '../../../state-management/organization-workspace/with-organ-workspace-state-base';
import { OrganWsShardStateService } from '../../../state-management/organization-workspace/organ-ws-shard-state.service';
import { IOrgContext } from '../../../../models/organization/organization-model';

@Injectable()
export class OrganizationApiManagerService {
    private orgContext: IOrgContext;

    constructor(private orgApIService: OrganizationApiService) {}

    public createNewOrganizationAsync(name: string) {
        return handleApiCallAsync(this.orgApIService.createNewOrg$(name));
    }

    /**
     * Gets all the organizations metadata
     */
    public getAllOrganizationsMDAsync() {
        return handleApiCallAsync(this.orgApIService.getAllOrganizationsMD$());
    }

    public getOrganizationAsync(organId: string) {
        return handleApiCallAsync(this.orgApIService.getOrganization$({ organizationId: organId }));
    }

    public updateOrganizationFields(body: IUpdateOrganizationRequestBody) {
        return handleApiCallAsync(this.orgApIService.updateOrganizationFields$(this.orgContext, body));
    }
    getWorkspacesPaginatedAsync(options: IPaginationQuery) {
        return handleApiCallAsync(this.orgApIService.getWorkspacesPaginated$(this.orgContext, options));
    }
    public setOrgContext(orgContext: IOrgContext) {
        this.orgContext = orgContext;
    }
}
